<template>
  <div
    id="pnlPreviewPDF"
    class="border-2 border-royal-blue-20 rounded-sm my-8 p-8">
    <h2 class="font-bitter text-2xl font-bold mb-4">
      Preview your submission files
    </h2>
    <p class="mb-4">
      This preview compiles all of your files into one PDF so you can quickly check everything.<br />
      This PDF will open in a new tab. It may take several minutes to load.
    </p>
    <ButtonComponent
      label="Preview PDF"
      variant="primary"
      id="btnViewProof"
      @customClick="openPdf"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { SubmissionFile, SubmissionFileType } from '@/types'
import pdfApi from '../../api/pdf-api'
import { useStore } from 'vuex'
import ButtonComponent from '../ui-components/ButtonComponent.vue'

const store = useStore()

const submissionId = computed((): string => {
  return store.state.activeSubmission.submissionId
})

const files = computed((): SubmissionFile[] => {
  return store.getters.submissionFiles
})

const pdfUrl = computed((): string => {
  const displayableFileTypes = [SubmissionFileType.CoverLetter, SubmissionFileType.MainArticle, SubmissionFileType.DAS, SubmissionFileType.Figure, SubmissionFileType.Esi]
  const relevantFiles = files.value.filter(
    (file: SubmissionFile) => displayableFileTypes.includes(file.type),
  )
  const fileIds = relevantFiles.map((file: SubmissionFile) => file.id)
  return pdfApi.getPreviewPdfUrl(submissionId.value, fileIds)
})

const openPdf = () => {
  if (pdfUrl.value) {
    window.open(pdfUrl.value, '_pdfPreview')
  }
}
</script>
